import React from 'react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { timePickerStyles } from './FilterTimePicker.styles';

interface TimePickerProps {
  id: string;
  label: string;
  error?: boolean;
  onChange?: (date: Date) => void;
  value?: string | number | Date | undefined;
  disabled: boolean;
}

const FilterTimePicker = React.memo((props: TimePickerProps) => {
  const { id, label, onChange, value, disabled } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        sx={timePickerStyles.timePicker}
        slotProps={{
          textField: {
            id: id,
            label: label,
            disabled: disabled,
          },
        }}
        onChange={onChange}
        value={value as Date}
      />
    </LocalizationProvider>
  );
});

export default FilterTimePicker;
